<div class="content-wrapper-inner relative">
    <div class="page-content">
        <div class="table-topbar mb-20">
            <div class="search-holder">
                <input type="search" placeholder="Search" class="form-control table-search" [formControl]="searchControl" />
                <span class="icon-search"></span>
            </div>
            <div class="table-action-holder">
                <div class="import me-20 cp" (keyup.enter)="onClickImport()" tabindex="0" (click)="onClickImport()" tooltip="Import SIP configurations">
                    <a class="bg-neutral-n1"><span class="icon-import fs-4 text-neutral-n9"></span></a>
                </div>
                <div class="create">
                    <a (click)="onCreate()" class="btn btn-primary py-10 px-15"><span class="icon-add"></span>Create SIP Trunk</a>
                </div>
            </div>
        </div>
        <div class="dataTables_wrapper form-inline dt-bootstrap pos-relative">
            <app-sip-config-table (changeBatch)="selectedRows = $event" (actions)="onAction($event)"></app-sip-config-table>
            <div class="table-action-info-bar" *ngIf="selectedRows.length">
                <div class="info-left">
                    <div class="text-icon-holder" (click)="batchClear()">
                        <span class="icon">
                            <span class="selected icon-done"></span>
                        </span>
                        <span class="text">{{ selectedRows.length }} Selected</span>
                    </div>
                </div>
                <div class="info-right">
                    <div class="text-icon-holder" (click)="onBatchDelete()">
                        <span class="icon">
                            <span class="far fa-trash-alt"></span>
                        </span>
                        <span class="text">Delete</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #formModalTpl let-dialogRef="dialogRef">
    <div class="modal-header mb-10">
        <div class="modal-title">
            <h3 *ngIf="editModel" class="d-inline-block">{{ editModel.id ? "Edit" : "Create" }} SIP Trunk</h3>
            <button type="button" class="btn-close" (click)="onCloseModal()">
                <span class="icon-close"></span>
            </button>
        </div>
    </div>

    <div *ngIf="editModel" class="modal-body">
        <app-sip-config-form [model]="editModel" (onCancel)="onCloseModal()" (onAfterSave)="onAfterSave()"></app-sip-config-form>
    </div>
</ng-template>

<ng-template #importModalTpl let-dialogRef="dialogRef">
    <div class="modal-header mb-10">
        <div class="modal-title">
            <h3 class="d-inline-block">Import from excel</h3>
            <button type="button" class="btn-close" (click)="dialogRef.close(true)">
                <span class="icon-close"></span>
            </button>
        </div>
    </div>
    <div class="modal-body">
        <app-sip-config-import (finished)="importFinished($event)" (closed)="importModal.close(true)"></app-sip-config-import>
    </div>
</ng-template>
